import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {ISnackbarType} from "../../types/SnackbarTypes"

export interface InitialState{
  snackbar:ISnackbarType
}

const initialState: InitialState = {
  snackbar:{
    severity: "success",
    message:"",
    open:false,
    stayOpen:false
  }
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSnackBar: (state: any, action: PayloadAction<ISnackbarType>) => {
      state.snackbar = action.payload;
    },
  }
});


export const { setSnackBar } = snackbarSlice.actions;
